
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import OriginVhostRepositoryInterface, {
  OriginVhostInterface,
  OriginVhostPHPConfigParameterInterface,
  OriginVhostPHPModuleInterface,
} from '@/services/Vhost/Origin/Interfaces';
import { ServerInterface } from '@/services/Server/Interfaces';
import { Website } from '@/services/Website/interfaces';
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

@Component({
  mixins: [Themeable],
  inject: ['originVhostRepository'],
})
export default class VhostPHPConfigDialog extends Vue {
  @Prop() public data: { vhost: OriginVhostInterface, server: ServerInterface, website: Website };

  public visible: boolean = true;

  public loading: boolean = true;

  public originVhostRepository!: OriginVhostRepositoryInterface;

  public phpModules: OriginVhostPHPModuleInterface[] = [];

  public phpConfigParameters: OriginVhostPHPConfigParameterInterface[] = [];

  public selectedModules: OriginVhostPHPModuleInterface[] = [];

  public textInputParametersIds: number[] = [1, 2];

  public selectInputParametersIds: number[] = [3];

  public itemsMap: { [id: number]: string[] } = {
    3: [],
  };

  public validationMap: { [id: number]: FormValidationFunction[] } = {
    1: [this.validateMemoryValue],
    2: [this.validateMemoryValue],
    3: [(value) => this.validateListValue(3, value)],
  };

  public config: { [parameterId: number]: string | string[] } = {};

  public validConfig: boolean = false;

  public async created(): Promise<void> {
    await this.initialize();
    this.loading = false;
  }

  public async initialize(): Promise<void> {
    this.phpModules = await this.originVhostRepository.getPHPModules();
    this.selectedModules = this.data.vhost.php.modules;
    this.phpConfigParameters = await this.originVhostRepository.getPHPConfigParameters();

    this.phpConfigParameters.forEach((parameter) => {
      this.config[parameter.id] = '';
    });

    this.data.vhost.php.config.forEach((config) => {
      if (this.selectInputParametersIds.includes(config.parameter.id)) {
        const values = config.value.split(',');

        this.config[config.parameter.id] = values;
        this.itemsMap[config.parameter.id] = values;

        return;
      }

      this.config[config.parameter.id] = config.value;
    });
  }

  public updateConfig(): void {
    const configs = Object.keys(this.config).map((key) => ({
      parameter: Number(key),
      value: Array.isArray(this.config[Number(key)])
        ? (this.config[Number(key)] as string[]).join(',')
        : this.config[Number(key)],
    })).filter((config) => !!config.value);

    this.$emit(
      'updateConfig',
      {
        configs,
        modules: this.selectedModules.map((module) => module.id),
      },
      this.data.vhost.id,
    );

    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  public validateConfig(): void {
    const keys = Object.keys(this.config).map((key) => Number(key));

    this.validConfig = keys
      .map((key) => this.validationMap[key].every((func) => func(this.config[key]) === true))
      .every((res) => res);
  }

  public validateMemoryValue(value: string): boolean | string {
    return !value || /^\d+(:?[k,M,G])$/.test(value) || 'Invalid memory value! Value should include suffix (k,M,G)';
  }

  public validateListValue(parameterId: number, value: string[]): boolean | string {
    if (!value || value.length === 0) {
      return true;
    }

    return value.every((v) => v.length > 1);
  }
}
